import React from 'react';
import { motion } from 'framer-motion';
import { Upload, ArrowRight, Layers } from 'lucide-react';
import { Button } from './ui/Button';
export function GangSheetBuilder() {
  return <section id="dtf" className="py-16 bg-atomic-charcoal border-y border-white/10" data-id="element-158">
      <div className="container mx-auto px-4 md:px-6" data-id="element-159">
        <div className="max-w-6xl mx-auto" data-id="element-160">
          {/* Top Section: Intro */}
          <div className="text-center mb-12" data-id="element-161">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-162">
              DTF Printing & Shipping — Built for Speed, Shipped Nationwide
            </h2>
            <p className="text-lg text-gray-300 leading-relaxed max-w-3xl mx-auto mb-6" data-id="element-163">
              Enjoy fast production and free UPS Ground shipping on orders over
              $200. No weeding. No layering. Just press and go. We print and
              ship DTF transfers daily to customers across the U.S.
            </p>

            <a href="/dtf-printing" className="inline-flex items-center text-atomic-green hover:text-lime-400 font-medium transition-colors group" data-id="element-164">
              Learn about DTF Transfers
              <ArrowRight className="ml-2 w-4 h-4 transition-transform group-hover:translate-x-1" data-id="element-165" />
            </a>
          </div>

          {/* Two-Path Choice */}
          <div className="grid lg:grid-cols-2 gap-8" data-id="element-166">
            {/* Option 1: Gang Sheet Builder */}
            <motion.div initial={{
            opacity: 0,
            x: -20
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            delay: 0.1
          }} className="bg-atomic-black rounded-xl p-8 border-2 border-atomic-green/50 relative" data-id="element-167">
              <div className="absolute -top-3 left-6 px-3 py-1 bg-atomic-green text-black text-xs font-bold rounded-full" data-id="element-168">
                MOST POPULAR
              </div>

              <div className="flex items-start gap-4 mb-6" data-id="element-169">
                <div className="p-3 bg-atomic-green/20 rounded-lg text-atomic-green border border-atomic-green/30" data-id="element-170">
                  <Layers size={28} data-id="element-171" />
                </div>
                <div data-id="element-172">
                  <h3 className="text-2xl font-bold text-white mb-2" data-id="element-173">
                    Build Your Gang Sheet
                  </h3>
                  <p className="text-gray-400 text-sm" data-id="element-174">
                    Upload individual designs and we'll arrange them for you
                  </p>
                </div>
              </div>

              <ul className="space-y-3 mb-6" data-id="element-175">
                <li className="flex items-start gap-2 text-gray-300 text-sm" data-id="element-176">
                  <span className="text-atomic-green mt-1" data-id="element-177">✓</span>
                  <span data-id="element-178">Upload multiple design files</span>
                </li>
                <li className="flex items-start gap-2 text-gray-300 text-sm" data-id="element-179">
                  <span className="text-atomic-green mt-1" data-id="element-180">✓</span>
                  <span data-id="element-181">Specify quantities for each design</span>
                </li>
                <li className="flex items-start gap-2 text-gray-300 text-sm" data-id="element-182">
                  <span className="text-atomic-green mt-1" data-id="element-183">✓</span>
                  <span data-id="element-184">Automatic optimal arrangement</span>
                </li>
                <li className="flex items-start gap-2 text-gray-300 text-sm" data-id="element-185">
                  <span className="text-atomic-green mt-1" data-id="element-186">✓</span>
                  <span data-id="element-187">Perfect for teams, brands, and shops</span>
                </li>
              </ul>

              <a href="/dtf-printing#builder" data-id="element-188">
                <Button size="lg" className="w-full" data-id="element-189">
                  Start Building
                  <ArrowRight className="ml-2 w-4 h-4" data-id="element-190" />
                </Button>
              </a>
            </motion.div>

            {/* Option 2: Upload Pre-Built Gang Sheet */}
            <motion.div initial={{
            opacity: 0,
            x: 20
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            delay: 0.2
          }} className="bg-atomic-black rounded-xl p-8 border-2 border-white/20 hover:border-atomic-green/50 transition-colors" data-id="element-191">
              <div className="flex items-start gap-4 mb-6" data-id="element-192">
                <div className="p-3 bg-white/5 rounded-lg text-gray-400 border border-white/10" data-id="element-193">
                  <Upload size={28} data-id="element-194" />
                </div>
                <div data-id="element-195">
                  <h3 className="text-2xl font-bold text-white mb-2" data-id="element-196">
                    Upload Pre-Built Gang Sheet
                  </h3>
                  <p className="text-gray-400 text-sm" data-id="element-197">
                    Already have your gang sheet arranged? Upload it directly
                  </p>
                </div>
              </div>

              <ul className="space-y-3 mb-6" data-id="element-198">
                <li className="flex items-start gap-2 text-gray-300 text-sm" data-id="element-199">
                  <span className="text-atomic-green mt-1" data-id="element-200">✓</span>
                  <span data-id="element-201">Upload your completed gang sheet file</span>
                </li>
                <li className="flex items-start gap-2 text-gray-300 text-sm" data-id="element-202">
                  <span className="text-atomic-green mt-1" data-id="element-203">✓</span>
                  <span data-id="element-204">Quick checkout for repeat customers</span>
                </li>
                <li className="flex items-start gap-2 text-gray-300 text-sm" data-id="element-205">
                  <span className="text-atomic-green mt-1" data-id="element-206">✓</span>
                  <span data-id="element-207">Ideal if you've already arranged your designs</span>
                </li>
              </ul>

              <a href="/upload-gang-sheet" data-id="element-208">
                <Button variant="outline" size="lg" className="w-full" data-id="element-209">
                  Upload Gang Sheet
                  <ArrowRight className="ml-2 w-4 h-4" data-id="element-210" />
                </Button>
              </a>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}